import type { DesktopMode } from "@/stores/desktop-mode-store";

/** Compact owns its cursor and summon surfaces at the desktop shell level. */
export function shouldRenderWorkspaceInteractionLayers(mode: DesktopMode) {
  return mode !== "compact";
}
